import { useAppContext } from "../../context/appContext";
import { FaFileAlt, FaTimes } from "react-icons/fa";
import { getExtension } from "../../utils/fileNames";
import { normalizeImage } from "../../utils/normalizeImage";
import { Display, Input } from "../workspace";

const imageExtensions = ["jpg", "jpeg", "png", "gif", "bmp", "svg", "heic"];

function FileModal({ fileItems, setFileItems, cleanup }) {
  const { job, uploadFile, isLoading } = useAppContext();

  const handleNewName = (value, index) => {
    const updatedItems = [...fileItems];
    updatedItems[index] = { ...updatedItems[index], newName: value };
    setFileItems(updatedItems);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const jobPath = job.folder_path;
    for (let i = 0; i < fileItems.length; i++) {
      const item = fileItems[i];
      const extension = item.fileMetadata.name
        .split(".")
        .pop()
        .toLowerCase();
      try {
        let newFile;
        if (item.isImage || imageExtensions.includes(extension)) {
          newFile = await normalizeImage(
            item.fileMetadata,
            item.newName,
            { reduce: false }
          );
        } else {
          const fileExtension = getExtension(item.fileMetadata.name);
          newFile = new File([item.fileMetadata], item.newName + fileExtension, {
            type: item.fileMetadata.type,
          });
        }
        await uploadFile({ file: newFile, jobPath });
      } catch (error) {
        console.error("Error uploading file:", item.fileMetadata.name, error);
      }
    }
    cleanup();
  };

  const handleCancel = (e) => {
    console.log("action cancelled...");
    cleanup();
  };

  return (
    <form className="form photo-modal">
      {/* Close Button */}
      <button className="close-btn" type="button" onClick={handleCancel}>
        <FaTimes />
      </button>
      {/* Prompt Message */}
      <div className="form-center sub-item confirm-report">
        <h3>Upload New Files</h3>
        <div className="flex-parent whole">
          {fileItems.map((item, i) => (
            <div className="flex-parent whole photo-item" key={i}>
              <div className="one-fourth image-preview">
                {item.imagePreview ? (
                  <img
                    src={item.imagePreview}
                    alt="Preview"
                    style={{ maxWidth: "200px", maxHeight: "200px" }}
                  />
                ) : (
                  <div className="file-placeholder">
                    <FaFileAlt />
                    <span>
                      {item.fileMetadata.name.split(".").pop().toUpperCase()}
                    </span>
                  </div>
                )}
              </div>
              <div className="three-fourths">
                <div className="whole">
                  <Input
                    type="text"
                    name="fileName"
                    labelText="File Name"
                    value={item.newName || ""}
                    handleChange={(e) => handleNewName(e.target.value, i)}
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
        {isLoading && (
          <div className="whole">
            <Display
              name="uploadProgress"
              label="Progress"
              value="Uploading files..."
            />
          </div>
        )}
      </div>
      {/* Submit/ Clear Buttons */}
      <div className="btn-container flex-parent whole">
        <div className="one-half">
          <button
            name="confirmUpload"
            className="btn btn-block"
            type="button"
            disabled={isLoading}
            onClick={handleSubmit}
          >
            {isLoading ? "please wait..." : "confirm"}
          </button>
        </div>
        <div className="one-half">
          <button
            className="btn btn-block red"
            type="button"
            disabled={isLoading}
            onClick={handleCancel}
          >
            cancel
          </button>
        </div>
      </div>
    </form>
  );
}
export default FileModal;
